define.alias("ember-composable-helpers/helpers/pipe", "media/helpers/pipe");